// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1359":"UiCollection","2370":"Chat","4320":"CategoryList","5309":"Safety","5470":"Not Fount","5756":"Review","7693":"ItemDetail"}[chunkId] + "." + {"1359":"13aeea7f","2370":"739ebfa4","4320":"764e6f0f","5309":"db8f6274","5470":"dbedd903","5756":"692a0e17","7693":"17c916c4"}[chunkId] + ".css";
};